import React, { forwardRef } from 'react';
import styles from './Textarea.module.scss';

const Textarea = forwardRef(({
  value,
  onChange,
  placeholder = '',
  id,
  name,
  label,
  className = '',
  disabled = false,
  required = false,
  autoComplete,
  maxLength,
  minLength,
  rows = 4,
  cols,
  spellCheck,
  onFocus,
  onBlur,
  ...props
}, ref) => {
  // Generate an ID if none is provided
  const textareaId = id || `textarea-${name || label?.replace(/\s+/g, '-').toLowerCase() || Math.random().toString(36).substring(2, 9)}`;

  return (
    <div className={`${styles.textareaContainer} ${className} ${disabled ? styles.disabled : ''}`}>
      {label && (
        <label 
          htmlFor={textareaId}
          className={styles.label}
        >
          {label}{required && <span className={styles.required}>*</span>}
        </label>
      )}
      
      <textarea
        ref={ref}
        id={textareaId}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        className={styles.textarea}
        name={name}
        autoComplete={autoComplete}
        maxLength={maxLength}
        minLength={minLength}
        rows={rows}
        cols={cols}
        spellCheck={spellCheck}
        onFocus={onFocus}
        onBlur={onBlur}
        aria-required={required}
        {...props}
      />
    </div>
  );
});

Textarea.displayName = 'Textarea';

export default Textarea; 